import React, { FC } from "react";

import styled from "styled-components";
import { Colors } from "../../globalStyles";

function Label({ errorMessage }: any): JSX.Element {
  const LabelError = styled.p`
    color: ${Colors.error};
  `;

  return <LabelError>{errorMessage}</LabelError>;
}

export default Label;
